/* eslint-disable valid-typeof */

/**
 * @enum {string}
 */
export const DataType = {
    FUNCTION: 'function',
    NUMBER: 'number',
    STRING: 'string',
    UNDEFINED: 'undefined',
};

/**
 * Checks if the provided object has no enumerable own properties.
 *
 * This utility is designed to replace the jQuery {@link https://api.jquery.com/jQuery.isEmptyObject/ $.isEmptyObject()} method.
 *
 * @param {any} value The value to check.
 * @returns {boolean} True if the object has no enumerable own properties.
 */
export function isEmptyObject(value) {
    return value == null || Object.keys(value).length === 0;
}

/**
 * Checks if the provided value is a function.
 *
 * This utility is designed to replace the jQuery {@link https://api.jquery.com/jQuery.isFunction/ $.isFunction()} method.
 *
 * @param {any} value The value to check.
 * @returns {boolean} True indicates the value is a 'function'.
 */
export function isFunctionType(value) {
    return typeof value === DataType.FUNCTION;
}

/**
 * @param {any} value The value to check.
 * @returns {boolean} True indicates the value is a 'number'.
 */
export function isNumberType(value) {
    return typeof value === DataType.NUMBER;
}

/**
 * Checks if the provided value is a plain object (like {} or new Object()).
 *
 * This utility is designed to replace the jQuery {@link https://api.jquery.com/jQuery.isPlainObject/ $.isPlainObject()} method.
 *
 * @param {any} value The value to check.
 * @returns {boolean} True if the value is a plain object.
 */
export function isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== '[object Object]') {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

/**
 * @param {any} value The value to check.
 * @returns {boolean} True indicates the value is a 'string'.
 */
export function isStringType(value) {
    return typeof value === DataType.STRING;
}

/**
 * @param {any} value The value to check.
 * @returns {boolean} True indicates the value is 'undefined'.
 */
export function isUndefinedType(value) {
    return typeof value === DataType.UNDEFINED;
}
